module.exports = __webpack_public_path__ + "static/media/Addington-By-Laws-2015.ed21d951.pdf";